/** @prettier */
import { useMemo } from 'react';

import { DOCUMENT_STATUSES } from '@xanadu/ui-shared/modules/user/data';

const DOCS_OK_STATUSES = [DOCUMENT_STATUSES.APPROVED, DOCUMENT_STATUSES.NOT_AVAILABLE];

const useExternalDocsUploader = ({ POIStatus, POAStatus }) => {
  const currentStatuses = [POAStatus, POIStatus];

  const showExternalDocsUploader = useMemo(() => {
    const docsNotOk = currentStatuses.some((docStatus) => !DOCS_OK_STATUSES.includes(docStatus));

    const additionalDocs = currentStatuses.some(
      (docStatus) => docStatus === DOCUMENT_STATUSES.ADDITIONAL_DOCS
    );

    return docsNotOk && !additionalDocs;
  }, [POIStatus, POAStatus]);

  return showExternalDocsUploader;
};

export default useExternalDocsUploader;
